/**
 * Store Comptes
 */
export default {
    state: {
        comptes: [],
    },

    mutations: {
        /**
         * Initialise le state comptes
         */
        setComptes: function (state, comptes) {
            state.comptes = comptes
        }
    },

    actions: {
        /**
         * Initialise le state comptes
         */
        initComptes: function (context) {
            if (context.state.comptes.length === 0) {
                return axios.get('/api/comptes').then(response => {
                    context.commit('setComptes', response.data.data)
                })
            }
        }
    },

    getters: {
        /**
         * Liste d'options de statuts de dossiers
         */
        optionsComptes: state => {
            return state.comptes.map(compte => {
                return {label: compte.nom, value: compte.id}
            })
        },
    }
}
